import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import handleAddToCart from "./addtocartfunction"; // Import the add to cart function
const OrganicOne = () => {
  const [products, setProducts] = useState([]);

  const CK = process.env.REACT_APP_WC_CK;
  const CS = process.env.REACT_APP_WC_CS;

  function SampleNextArrow({ className, onClick }) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }

  function SamplePrevArrow({ className, onClick }) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1599, settings: { slidesToShow: 6 } },
      { breakpoint: 1399, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 575, settings: { slidesToShow: 2 } },
      { breakpoint: 424, settings: { slidesToShow: 1 } },
    ],
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch("https://ecoms.brightcodeapp.com/api/organic-products/");
        const data = await res.json();

        if (data.status) {
          
          setProducts(data.data);
        }
      } catch (err) {
        console.error("Failed to load Organic Food products", err);
      }
    };

    fetchProducts();
  }, []);

  return (
    <section className="organic-food py-80">
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">Organic Food</h5>
            <div className="flex-align mr-point gap-16">
              <Link
                to="/shop"
                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
              >
                All Categories
              </Link>
            </div>
          </div>
        </div>

        <div className="organic-food__slider arrow-style-two">
          <Slider {...settings}>
            {products.map((p) => (
              <div key={p.id}>
                <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                  {p.on_sale && (
                    <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                      Sale {Math.round(((p.regular_price - p.sale_price) / p.regular_price) * 100)}%
                    </span>
                  )}
                  <Link to={`/product-details/${p.id}`} className="product-card__thumb flex-center">
                    <img src={p.images?.[0]?.src} alt={p.name} />
                  </Link>

                  <div className="product-card__content mt-12">
                    <div className="flex-align gap-6">
                      <span className="text-xs fw-bold text-gray-500">
                        {p.average_rating || "0.0"}
                      </span>
                      <span className="text-15 fw-bold text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                      </span>
                      <span className="text-xs fw-bold text-gray-500">
                        ({p.rating_count || 0})
                      </span>
                    </div>

                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                      <Link to={`/product-details/${p.id}`} className="link text-line-2">
                        {p.name}
                      </Link>
                    </h6>

                    <div className="flex-align gap-4">
                      <span className="text-main-600 text-md d-flex">
                        <i className="ph-fill ph-storefront" />
                      </span>
                      <span className="text-gray-500 text-xs">
                        By {p.store?.name || "Store"}
                      </span>
                    </div>

                    <div className="flex-between gap-8 mt-24 flex-wrap">
                      <div className="product-card__price">
                        {p.on_sale && (
                          <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                            ₹{p.regular_price}
                          </span>
                        )}
                        <span className="text-heading text-md fw-semibold">
                          ₹{p.price}{" "}
                          <span className="text-gray-500 fw-normal">/Qty</span>
                        </span>
                      </div>

                      <button
                        onClick={() => handleAddToCart(p.id)}
                        className="product-card__cart btn btn-main py-11 px-24 rounded-pill flex-align gap-8"
                      >
                        Add <i className="ph ph-shopping-cart" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default OrganicOne;
